// 存在フラグ用 Cookie の読み書き。属性（path=/・SameSite=Lax・https のときだけ Secure）はここで統一する。

export function hasCookie(key) {
  return document.cookie.split(';').some(c => c.trim().startsWith(`${key}=`))
}

// maxAge（秒）を省略するとセッション Cookie（ブラウザを閉じると失効）になる
export function writeFlagCookie(key, { maxAge } = {}) {
  // HTTP（ローカル開発）では Secure 付き Cookie が保存されないため本番のみ付与
  const secure = window.location.protocol === 'https:' ? ';Secure' : ''
  const maxAgeAttr = maxAge === undefined ? '' : `;max-age=${maxAge}`
  document.cookie = `${key}=1;path=/${maxAgeAttr};SameSite=Lax${secure}`
}
